import { render, staticRenderFns } from "./PhBbModuleRoot.vue?vue&type=template&id=fea01ab0&scoped=true&lang=html&"
import script from "./PhBbModuleRoot.vue?vue&type=script&lang=js&"
export * from "./PhBbModuleRoot.vue?vue&type=script&lang=js&"
import style0 from "./PhBbModuleRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea01ab0",
  null
  
)

export default component.exports